// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Icon from '@mui/material/Icon'
import Typography from '@mui/material/Typography'
import find from 'lodash/find'
import isEqual from 'lodash/isEqual'
import React from 'react'
import { Trans } from 'react-i18next'
import { i18n } from '../../index'
import { Station } from '../../station/stationTypes'
import EmployeeAdditionalInfo from './EmployeeAdditionalInfo'
import css from './IncentivesPanel.css'
import type { StaffMember } from './types'
// import type {ActivityDescription} from '../../activityDescription/ActivityDescriptionTypes'

type ActivityDescription = {
  id: string
  name: string
  description: string
  station: Station
}

type Props = {
  staffMembers: Array<StaffMember>
  label: string
  currentEmployeeId: string
  employeeChanged: (...args: Array<any>) => any
  activityDescriptions: Array<ActivityDescription>
}
type State = {
  isDialogOpen: boolean
}

class StaffMembersSelect extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      isDialogOpen: false,
    }
    this.openDialog = this.openDialog.bind(this)
    this.closeDialog = this.closeDialog.bind(this)
  }

  componentDidMount() {
    const { employeeChanged, staffMembers } = this.props

    if (staffMembers.length > 0) {
      employeeChanged(staffMembers[0].user.id, staffMembers)
    }
  }

  componentDidUpdate(prevProps: Props) {
    const { staffMembers, currentEmployeeId, employeeChanged } = this.props
    const oldMemeber = [...prevProps.staffMembers].find((member) => member.user.id === currentEmployeeId)
    const updatedMemember = staffMembers.find((member) => member.user.id === currentEmployeeId)

    if (!isEqual(oldMemeber, updatedMemember)) {
      employeeChanged(currentEmployeeId, staffMembers)
    }
  }

  pickupEmployee(chosenEmployeeId: string) {
    const { employeeChanged, staffMembers } = this.props
    this.setState(
      {
        isDialogOpen: false,
      },
      () => {
        employeeChanged(chosenEmployeeId, staffMembers)
      },
    )
  }

  openDialog() {
    this.setState({
      isDialogOpen: true,
    })
  }

  closeDialog() {
    this.setState({
      isDialogOpen: false,
    })
  }

  userBtnName(name: string) {
    const nameArray = name.split(' ')
    let lastName = nameArray.pop()
    lastName = lastName.length > 3 ? lastName.slice(0, 3) : lastName
    nameArray.push(lastName)
    return nameArray.join(' ')
  }

  render() {
    const { staffMembers, label, currentEmployeeId, activityDescriptions, reservations, date } = this.props
    const { isDialogOpen } = this.state
    const currentEmployee = find(staffMembers, {
      user: {
        id: currentEmployeeId,
      },
    })
    const currentEmployeeName = currentEmployee ? currentEmployee.user.name : ''
    const reservationsCount = reservations.length
    return staffMembers.length > 0 ? (
      <div className={css.wrapper}>
        <div className={css.employeeSelect}>
          <Typography variant='caption'>{label}</Typography>
          <div className={css.selectedEmployee} onClick={this.openDialog}>
            <Typography variant='h5'>{currentEmployeeName}</Typography>
            <Icon>arrow_drop_down</Icon>
          </div>
          <Dialog open={isDialogOpen} onClose={this.closeDialog} maxWidth='md' className={css.employeeDialog}>
            <DialogTitle className={css.employeeDialogTitle}>{i18n.t('employeeCard.selectEmployee')}</DialogTitle>
            <DialogContent className={css.employeeDialogContent}>
              {staffMembers.map(({ user }) => (
                <Button
                  key={user.id}
                  variant='contained'
                  color='primary'
                  onClick={() => this.pickupEmployee(user.id)}
                  className={css.employeeSelectBtn}
                >
                  {this.userBtnName(user.name)}
                </Button>
              ))}
            </DialogContent>
            <DialogActions className={css.employeeDialogActions}>
              <Button type='button' onClick={this.closeDialog}>
                {i18n.t('buttons.cancel')}
              </Button>
            </DialogActions>
          </Dialog>
        </div>
        {currentEmployee && (
          <EmployeeAdditionalInfo
            employee={currentEmployee}
            activityDescriptions={activityDescriptions}
            reservationsCount={reservationsCount}
            date={date}
          />
        )}
      </div>
    ) : (
      <Typography variant='h6'>
        <Trans i18nKey='employeeCard.addStaffMember' components={{ lnk: <a href='/vuorokausijohtaminen' /> }} />
      </Typography>
    )
  }
}

export default StaffMembersSelect
